<span class="no-rows-overlay-custom-wrapper">
    <svg [ngClass]="noRowsOverlayIconClass">
        <use [attr.href]="noRowsOverlayIconPath"></use>
    </svg>
    <span class="no-rows-overlay-custom-text">{{noRowsOverlayText}}</span>
</span>